import * as crypto from 'crypto';

const decrypt = (data: string) => {
  if (!process.env.ENV_SECRET || process.env.NODE_ENV === 'development') {
    return data;
  }

  const decipher = crypto.createDecipheriv('aes-128-ecb', process.env.ENV_SECRET || '', '');
  const decryptedData = decipher.update(Buffer.from(data, 'hex'));
  return Buffer.concat([decryptedData, decipher.final()]).toString();
};

export const env = (function () {
  const envMap = new Map();

  return function env(envName: string) {
    if (!envName) {
      return undefined;
    }

    if (typeof window !== 'undefined' && (window as any).__ENV?.[envName]) {
      if (envMap.has(envName)) {
        return envMap.get(envName);
      }
      const decryptEnv = decrypt((window as any).__ENV[envName]);
      envMap.set(envName, decryptEnv);
      return decryptEnv;
    } else {
      return process.env[envName];
    }
  };
})();
